<template>
  <fragment>
  <div v-if="mini" :class="{ 'bg-success' : status, 'bg-danger': !status }"> </div>
  <h4 v-else>
    <small
      class="badge badge-pill"
      :class="status ? 'badge-success' : 'badge-danger'"
    >
      {{ status ? ativoText : inativoText }}
    </small>
  </h4>

  </fragment>
</template>
<script>
export default {
  name: "BadgeStatus",
  props: {
    mini: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: false
    },
    ativoText: {
      type: String,
      default: "Ativo"
    },
    inativoText: {
      type: String,
      default: "Inativo"
    }
  }
};
</script>
